<template>
    <div class="page-model" v-if="totalPage>1">
        <ul>
          <li class="prev" v-bind:class="{ disabled: currentPage == 1 }"><a href="#" v-on:click.prevent="prev()"></a></li>
          <li class="num" v-for="(item,index) in pageArr" v-bind:key="index">
            <a href="#" v-bind:class="{ active: currentPage == item }" v-on:click.prevent="go('click',item)">{{item}}</a>
          </li>
          <li class="point" v-if="this.currentPage<totalPage-4">...</li>
          <li class="num" v-if="this.currentPage<totalPage-5">
            <a href="#" v-bind:class="{ active: currentPage == totalPage}" v-on:click.prevent="go('click',totalPage)">{{totalPage}}</a>
          </li>
          <li class="next" v-bind:class="{ disabled: currentPage == totalPage }"><a href="#" v-on:click.prevent="next()"></a></li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'Page',
  data () {
    return {
      currentPage: 1,
      pageArr:[]
    }
  },
  created(){
    this.go('init',1);
  },
  props:['totalPage'],
  methods:{
    prev:function(){
      if(this.currentPage > 1){
        let page = this.currentPage - 1;
        this.go('click',page);
      }
    },
    go:function(type,page){
      this.currentPage = page;
      this.pageArr = [];
      if(page>=5){
        if(this.totalPage - page>=4){
          for(let i=page;i <= page+4;i++){
            this.pageArr.push(i);
          }
        }else{
          for(let i=this.totalPage-4;i <= this.totalPage;i++){
            this.pageArr.push(i);
          }
        }
      }else{
        if(this.totalPage <= 5){
          for(let i=1;i <= this.totalPage;i++){
            this.pageArr.push(i);
          }
        }else{
          for(let i=1;i <= 5;i++){
            this.pageArr.push(i);
          }
        }
      }
      if(type=="click"){
        this.$emit('changepage', this.currentPage);
        document.documentElement.scrollTop = 0;
      }

    },
    next:function(){
      if(this.currentPage < this.totalPage){
        let page = this.currentPage + 1;
        this.go('click',page);
      }
    }
  },
  watch:{
      totalPage(val){
        // 这样重新赋值后，就得到了父组件动态改变的数据
        this.go('init',1);
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page-model{
  width: 100%;
  overflow: hidden;
  padding: 50px 0;
  margin: 0 auto;
  text-align: center;
}
.page-model ul{
  padding:0;
  display: inline-block;
}
.page-model li{
  width: 25px;
  height: 25px;
  float: left;
  margin:0 4px;
}
.page-model li a{
  width: 25px;
  height: 25px;
  font-size:16px;
  line-height: 25px;
  color: #908782;
  display: block;
  text-align: center;
  border-radius: 50%;
}
.page-model li.num a:hover,.page-model li.num a.active{
  font-size: 14px;
  color: #fff;
  background: #D00717;
}
.page-model .prev,.page-model .next{
  margin:0 15px;
}
.page-model .prev a{
  width: 25px;
  height: 25px;
  display: block;
  background: url('../../assets/images/pagePrev.png') no-repeat left center;
  background-size: 100%;
}
.page-model .next a{
  width: 25px;
  height: 25px;
  display: block;
  background: url('../../assets/images/pageNext.png') no-repeat left center;
  background-size: 100%;
}
@media (max-width:768px){
  .page-model li{
    margin:0 2px;
  }
  .page-model .prev,.page-model .next{
    margin:0 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/default/Page.vue